/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown>, scope: NonNullable<unknown> }} Task_Catalog_Remove_TitleInputs */

const en_task_catalog_remove_title = /** @type {(inputs: Task_Catalog_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.task} from ${i?.scope}?`)
};

const pt_br2_task_catalog_remove_title = /** @type {(inputs: Task_Catalog_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.task} de ${i?.scope}?`)
};

/**
* | output |
* | --- |
* | "Remove {task} from {scope}?" |
*
* @param {Task_Catalog_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_remove_title = /** @type {((inputs: Task_Catalog_Remove_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Remove_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_remove_title(inputs)
	return pt_br2_task_catalog_remove_title(inputs)
});